import { useTranslation } from "react-i18next";
import { ModalComponent, TypographyComponent } from "../../../gravity";

type InitAccessRevokedDialogComponentProps = {
  userFullName: string;
  handleClick: () => void;
  isOpen: boolean;
};

export const InitAccessRevokedDialogComponent = ({
  userFullName,
  handleClick,
  isOpen
}: InitAccessRevokedDialogComponentProps) => {
  const { t } = useTranslation();

  return (
    <ModalComponent
      confirmLabel={t("Back to My Evaluations")}
      isOpen={isOpen}
      onConfirm={handleClick}
      size="small"
      title={t("You No Longer Have Access to This Evaluation")}
      cancelLabel=""
      onCancel={handleClick}
    >
      <TypographyComponent styling="p-default">
        {userFullName}
        {` `}
        {t("has revoked your access to edit and view this evaluation.")}
      </TypographyComponent>
    </ModalComponent>
  );
};
